import { Injectable } from "@angular/core";
import { Constants } from "src/app/models/constants";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ConfigParamService {
  constructor(private httpClient: HttpClient) {}
  fetchconfigParam(groupcode) {
    let url = `${Constants.KSA_ADMIN_BASE_API_URL}/getConfigPrmt.do`;
    var postData = {
      req: {
        groupCode: groupcode,
      },
    };
    let reqdata = JSON.stringify(postData);
    // return this.httpClient.get("assets/data/ksa/config-paramdata.json");
    return this.httpClient.post<any>(url, reqdata);
  }

  addUnit(reqdata) {
    let url = `${Constants.KSA_ADMIN_BASE_API_URL}/addConfigEunit.do`;
    return this.httpClient.post<any>(url, JSON.stringify(reqdata));
  }
  updateConfigParam(reqdata) {
    let url = `${Constants.KSA_ADMIN_BASE_API_URL}/updateConfigPrmtKsa.do`;
    

    var header=new HttpHeaders();
    header.append('Content-Type', 'application/json; charset=UTF-8');
    return this.httpClient.post<any>(url ,JSON.stringify(reqdata), {headers : new HttpHeaders({ 'Content-Type': 'application/json;charset=UTF-8' })});

  }
}
